import React from "react";

const PartnerPageContext = React.createContext();

export { PartnerPageContext };
